const isCarvanaMobileAppUserAgent = () => /CarvanaNativeWebView/gi.test(navigator.userAgent);

export default isCarvanaMobileAppUserAgent;
